<template>
  <PageLoadMore v-if="state.article" :data="state.article" />
</template>

<script setup lang="ts">
import useArticle from '~/composables/useArticle';
import type { TArticle, TArticleType } from '~~/types/local_types';

const articleType: TArticleType = 'artikelen';

interface IState {
  article?: TArticle;
  variant: string;
  redirectChecked?: boolean;
}
const state = reactive<IState>({
  variant: useIsChildPageOf(),
});

const article = await useArticle(articleType);

if (!article || !article.slug) {
  throw createError({ statusCode: 404, statusMessage: 'Pagina niet gevonden' });
}

state.article = article;

usePageSeo({ content: article });

state.redirectChecked = await useCheckRedirect(
  article.slug,
  article.articleType,
  article.externalUrl,
);

if (import.meta.client) {
  const { splitType } = formatUtils();
  const { chapter1, chapter2 } = splitType(article.articleType);
  sendAnalytics({
    prefix: article.articleType,
    chapter1,
    chapter2,
    slug: article.slug,
  });
}

onMounted(() => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
});
</script>

<style scoped lang="postcss"></style>
